import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import noCatalogues from "../../assets/img/List_Is_Empty.svg";
import NoProductFound from "../../assets/img/NoProductFound.svg";
import Navbar from "../../components/navbar/Navbar";
import ProductCard from "../../components/ProductCard/ProductCard";
import BrandCarousel from "../../components/BrandCarousel/BrandCarousel";
import CategoryGrid from "../../components/CategoryGrid/CategoryGrid";
import Footer from "../../components/footer/Footer";
import CatalogueCard from "../../components/CatalogueCard/CatalogueCard";

const ProductNewDesign = () => {
  document.title = "Products";

  const [data, setData] = useState([]);
  const [catalogues, setCatalogues] = useState([]);
  const [loading, setLoading] = useState(true);
  const dataLength = 8; // number of products to show initially

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catalogueRes, contentRes] = await Promise.all([
          fetch("https://backend-server-nine-opal.vercel.app/catalogues"),
          fetch("https://backend-server-nine-opal.vercel.app/contents"),
        ]);

        const [catalogueData, contentData] = await Promise.all([
          catalogueRes.json(),
          contentRes.json(),
        ]);

        setCatalogues(catalogueData);
        setData(contentData);
      } catch (err) {
        console.error("Error fetching:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Skeleton Loader for Products
  const ProductSkeleton = () => (
    <div className="border rounded-md p-4 animate-pulse">
      <div className="bg-gray-300 h-40 w-full mb-4"></div>
      <div className="h-4 bg-gray-300 mb-2"></div>
      <div className="h-4 bg-gray-300 w-1/2"></div>
    </div>
  );

  // Skeleton Loader for Catalogues
  const CatalogueSkeleton = () => (
    <div className="border rounded-md p-4 animate-pulse">
      <div className="bg-gray-300 h-48 w-full mb-4"></div>
      <div className="h-4 bg-gray-300 mb-2"></div>
      <div className="h-4 bg-gray-300 w-3/4"></div>
    </div>
  );

  return (
    <div id="Products" className="mx-auto pt-24">
      <Navbar />

      <div className="container px-4 lg:px-0 mx-auto">
        <h1 className="text-3xl font-light underline">Our All Products</h1>

        {/* Brand Section */}
        <BrandCarousel />

        {/* Categories Section */}
        <div>
          <h1 className="lg:text-2xl mb-4 text-left underline font-semibold">
            Categories
          </h1>
          <CategoryGrid />
        </div>

        {/* Product List */}
        <div className="mt-12 pb-10">
          <div className="flex justify-between items-center mb-6">
            <h2 className="lg:text-2xl text-left underline font-semibold">
              All Products
            </h2>
            <Link to={`/productListView`}>
              <button className="flex items-center font-semibold text-[#1C3A27] hover:text-[#1DA14D]">
                View more products
                <MdKeyboardDoubleArrowRight />
              </button>
            </Link>
          </div>

          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 [@media(min-width:1440px)]:grid-cols-4 xl:grid-cols-5 gap-4">
              {Array.from({ length: dataLength }).map((_, i) => (
                <ProductSkeleton key={i} />
              ))}
            </div>
          ) : data.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10">
              <img
                src={NoProductFound}
                alt="No products found"
                className="w-64 h-64 object-contain"
              />
              <p className="mt-4 text-lg font-semibold text-gray-600">
                No products available
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 [@media(min-width:1440px)]:grid-cols-4 xl:grid-cols-5 gap-4">
              {data.slice(0, dataLength).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          )}
        </div>

        {/* Catalogue Section */}
        <div className="my-12">
          <h1 className="lg:text-2xl mb-4 font-semibold text-left underline">
            Products Catalogue
          </h1>
          {loading ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 [@media(min-width:1440px)]:grid-cols-4 gap-6 mt-6">
              {Array.from({ length: 4 }).map((_, i) => (
                <CatalogueSkeleton key={i} />
              ))}
            </div>
          ) : catalogues.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10">
              <img
                src={noCatalogues}
                alt="No catalogues found"
                className="w-64 h-64 object-contain"
              />
              <p className="mt-4 text-lg font-semibold text-gray-600">
                No catalogues available
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 [@media(min-width:1440px)]:grid-cols-4 gap-6 mt-6">
              {catalogues.map((cat) => (
                <CatalogueCard key={cat._id} catalogue={cat} />
              ))}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductNewDesign;
